<template>
  <v-row :class="{ 'text-center': !$vuetify.breakpoint.xsOnly }">
    <v-col cols="12">
      <vue-gallery :options="options" :images="images" :index="index" @close="index = null" />
      <v-btn no-caps type="link" text @click="index = 0" color="primary">
        <span class="text-capitalize text-center" style="text-decoration: underline;" v-if="!$vuetify.breakpoint.xsOnly">
          Klik sini untuk melihat tambahan keperluan <br /> pematuhan pelesenan perniagaan mengikut aktiviti perniagaan
        </span>
        <span class="text-capitalize text-left" style="text-decoration: underline;" v-if="$vuetify.breakpoint.xsOnly">
          Klik sini untuk melihat <br/> tambahan keperluan pematuhan <br /> pelesenan perniagaan mengikut <br /> aktiviti perniagaan
        </span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  name: 'AdditionalDocument',
  data: () => ({ images: [], index: null, options: { continuous: false } }),
  components: { VueGallery },
  mounted () {
    if (this.images.length === 0) {
      for (let i = 1; i <= 18; i++) {
        this.images.push(`${window.location.origin}img/additional_documents/${i}.jpg`)
      }
    }
  }
}
</script>
